import gql from 'graphql-tag';
import ApolloClient from 'apollo-boost';
import { get as _get } from 'lodash-es';
import productToSkuMap from '../ProductSkuMap.json';

let pageNextReady = '';
let lastProductCursor = '';
let XrsProductsFeed = [];

let NumLoop = [];
// TODO only run this code if Magento is the active platform
// TODO: Get rid of Apollo/graphql-tag dependency to remove the 34.15KB (gzipped) penalty
/*

    shop {
      currencyCode
    }
*/
const GET_PRODUCTS = gql`
  query prods($firstNum: Int, $prods: String) {
    products(first: $firstNum, query: $prods) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          handle
          title
          productType
          descriptionHtml
          options {
            name
            values
          }
          variants(first: 40) {
            edges {
              node {
                id
                title
                priceV2 {
                  amount
                  currencyCode
                }
                compareAtPriceV2 {
                  amount
                  currencyCode
                }
                selectedOptions {
                  name
                  value
                }
                image {
                  url
                  id
                }
                sku
                availableForSale
              }
            }
          }
        }
      }
    }
  }
`;

const GET_COLLECTTION_PRODUCTS = gql`
  query prods($handleName: String!, $sortKey: ProductCollectionSortKeys) {
    collectionByHandle(handle: $handleName) {
      products(first: 250, sortKey: $sortKey) {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            handle
            title
            productType
            vendor
            createdAt
            images(first: 2) {
              edges {
                node {
                  url
                }
              }
            }
            variants(first: 40) {
              edges {
                node {
                  id
                  title
                  currentlyNotInStock
                  priceV2 {
                    amount
                    currencyCode
                  }
                  compareAtPriceV2 {
                    amount
                    currencyCode
                  }
                  sku
                  availableForSale
                  image {
                    url
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
//getLastProduct
const GET_COLLECTTION_PRODUCTS_LOOP = gql`
  query prods(
    $firstNum: Int
    $handleName: String!
    $sortKey: ProductCollectionSortKeys
    $lastProduct: String!
  ) {
    collectionByHandle(handle: $handleName) {
      products(first: $firstNum, sortKey: $sortKey, after: $lastProduct) {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            handle
            title
            productType
            vendor
            createdAt
            images(first: 2) {
              edges {
                node {
                  url
                }
              }
            }
            variants(first: 40) {
              edges {
                node {
                  id
                  title
                  currentlyNotInStock
                  priceV2 {
                    amount
                    currencyCode
                  }
                  compareAtPriceV2 {
                    amount
                    currencyCode
                  }
                  sku
                  availableForSale
                  image {
                    url
                    id
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const Shopify = {
  prodGlobalArray: [],
  getProductIdString: function(merchantProductIDs) {
    let producIds = [];
    // If "Load Compatio category data from static JSON" on the index.html is unchecked, uncomment below code and comment line 51

    // merchantProductIDs.forEach(sku => {
    //   let productMap = productToSkuMap.find(element => element.sku === sku);
    //   producIds.push(productMap.product.id);
    // });
    // let query = producIds.join(' OR id:');

    //if category data is static JSON.
    // console.log(merchantProductIDs,'merchantProductIDs')
    let query = merchantProductIDs.join(' OR id:');
    // console.log(merchantProductIDs,'merchantProductIDs')
    query = 'id:' + query;
    return query;
  },

  getProductsBySkus: function(
    merchantProductIDs,
    returnProductDataCallback,
    errorCallback
  ) {
    // console.log(merchantProductIDs,'merchantProductIDs')
    const client = new ApolloClient({
      uri: window.compatioConfig.shopify.apiEndpointUrl,
      headers: {
        'X-Shopify-Storefront-Access-Token':
          window.compatioConfig.shopify.shopifyStorefrontAccessToken,
      },
    });

    if (merchantProductIDs && merchantProductIDs.length > 0) {
      client
        .query({
          query: GET_PRODUCTS,
          variables: {
            firstNum: 250,
            prods: Shopify.getProductIdString(merchantProductIDs),
          },
        })
        .then(
          result => {
            returnProductDataCallback(
              Shopify.convertGraphQLToCompatioFormat(result)
            );
            // console.log(result);
          },
          rejected => {
            console.error(rejected);
            errorCallback();
          }
        );
    }
  },

  getProductsBySkusXrs: function(
    merchantProductIDs,
    returnProductDataCallback,
    errorCallback
  ) {
    const client = new ApolloClient({
      uri: window.compatioConfig.shopify.apiEndpointUrl,
      headers: {
        'X-Shopify-Storefront-Access-Token':
          window.compatioConfig.shopify.shopifyStorefrontAccessToken,
      },
    });

    var DataSmartBuilder = [];
    var i = 0;
    let chunk = (arr, size) =>
      arr.reduce(
        (acc, e, i) => (
          i % size ? acc[acc.length - 1].push(e) : acc.push([e]), acc
        ),
        []
      );
    let n = chunk(merchantProductIDs, 250).length;
    if (merchantProductIDs && merchantProductIDs.length > 0) {
      while (merchantProductIDs.length > 0) {
        client
          .query({
            query: GET_PRODUCTS,
            variables: {
              firstNum: 250,
              // prods: Shopify.getProductIdString(merchantProductIDs),
              prods: Shopify.getProductIdString(
                merchantProductIDs.splice(0, 250)
              ),
            },
          })
          .then(
            result => {
              i++;
              result.data.products.edges.forEach(e => {
                DataSmartBuilder.push(e);
              });
              if (i == n) {
                returnProductDataCallback(
                  Shopify.convertGraphQLToCompatioFormatXrs(
                    DataSmartBuilder,
                    []
                    // result.data.shop.currencyCode
                  )
                );
              }
              // returnProductDataCallback(
              //   Shopify.convertGraphQLToCompatioFormatXrsNew(result)
              // );
            },
            rejected => {
              console.error(rejected);
              errorCallback();
            }
          );
      }
    }
  },

  // New Fuction Increase product limit start in smartBuilder
  // here gaurav developer used a while loop function for getting all products from shopify graphql query for smart builder
  getDcProductsBySkus: function(
    merchantProductIDs,
    categoryID,
    returnProductDataCallback,
    errorCallback
  ) {
    const client = new ApolloClient({
      uri: window.compatioConfig.shopify.apiEndpointUrl,
      headers: {
        'X-Shopify-Storefront-Access-Token':
          window.compatioConfig.shopify.shopifyStorefrontAccessToken,
      },
    });
    var DataSmartBuilder = [];
    var i = 0;
    if (merchantProductIDs && merchantProductIDs.length > 0) {
      let chunk = (arr, size) =>
        arr.reduce(
          (acc, e, i) => (
            i % size ? acc[acc.length - 1].push(e) : acc.push([e]), acc
          ),
          []
        );
      let n = chunk(merchantProductIDs, 250).length;
      while (merchantProductIDs.length > 0) {
        client
          .query({
            query: GET_PRODUCTS,
            variables: {
              firstNum: 250,
              prods: Shopify.getProductIdString(
                merchantProductIDs.splice(0, 250)
              ),
            },
          })
          .then(
            result => {
              i++;
              result.data.products.edges.forEach(e => {
                DataSmartBuilder.push(e);
              });
              if (i == n) {
                returnProductDataCallback(
                  Shopify.convertGraphQLToCompatioFormatSmartBuilder(
                    DataSmartBuilder,
                    categoryID
                    // result.data.shop.currencyCode
                  )
                );
              }
            },
            rejected => {
              console.error(rejected);
              errorCallback();
            }
          );
      }
    }
  },

  //merchantProductSku is used for magento and shopify both as a common comparison field
  //need to use image from s3bucket/storage

  getProductsByCollection: function(
    handleName,
    sortKey,
    returnProductDataCallback,
    errorCallback
  ) {
    const client = new ApolloClient({
      uri: window.compatioConfig.shopify.apiEndpointUrl,
      headers: {
        'X-Shopify-Storefront-Access-Token':
          window.compatioConfig.shopify.shopifyStorefrontAccessToken,
      },
    });

    client
      .query({
        query: GET_COLLECTTION_PRODUCTS,
        variables: {
          handleName: handleName,
          sortKey: sortKey,
        },
      })
      .then(
        result => {
          var dataApi = [];
          result.data.collectionByHandle.products.edges.forEach(e => {
            dataApi.push(e);
          });
          pageNextReady =
            result.data.collectionByHandle.products.pageInfo.hasNextPage;

          if (pageNextReady == false) {
            returnProductDataCallback(
              Shopify.convertGraphQLToCollectionsFormatforCollections(dataApi)
            );
          } else {
            lastProductCursor =
              result.data.collectionByHandle.products.edges[249].cursor;
          }
          // console.log(pageNextReady, lastProductCursor, result,'1')
          if (pageNextReady == true) {
            client
              .query({
                query: GET_COLLECTTION_PRODUCTS_LOOP,
                variables: {
                  firstNum: 250,
                  handleName: handleName,
                  sortKey: sortKey,
                  lastProduct: lastProductCursor,
                },
              })
              .then(result => {
                result.data.collectionByHandle.products.edges.forEach(
                  element => {
                    dataApi.push(element);
                  }
                );
                pageNextReady =
                  result.data.collectionByHandle.products.pageInfo.hasNextPage;
                if (pageNextReady == false) {
                  returnProductDataCallback(
                    Shopify.convertGraphQLToCollectionsFormatforCollections(
                      dataApi
                    )
                  );
                } else {
                  lastProductCursor =
                    result.data.collectionByHandle.products.edges[249].cursor;
                }
                // console.log(pageNextReady, lastProductCursor, result,'2')
                if (pageNextReady == true) {
                  client
                    .query({
                      query: GET_COLLECTTION_PRODUCTS_LOOP,
                      variables: {
                        firstNum: 250,
                        handleName: handleName,
                        sortKey: sortKey,
                        lastProduct: lastProductCursor,
                      },
                    })
                    .then(result => {
                      result.data.collectionByHandle.products.edges.forEach(
                        element => {
                          dataApi.push(element);
                        }
                      );
                      pageNextReady =
                        result.data.collectionByHandle.products.pageInfo
                          .hasNextPage;

                      if (pageNextReady == false) {
                        returnProductDataCallback(
                          Shopify.convertGraphQLToCollectionsFormatforCollections(
                            dataApi
                          )
                        );
                      } else {
                        lastProductCursor =
                          result.data.collectionByHandle.products.edges[249]
                            .cursor;
                      }
                      // console.log(pageNextReady, lastProductCursor, result,'3')
                      if (pageNextReady == true) {
                        client
                          .query({
                            query: GET_COLLECTTION_PRODUCTS_LOOP,
                            variables: {
                              firstNum: 250,
                              handleName: handleName,
                              sortKey: sortKey,
                              lastProduct: lastProductCursor,
                            },
                          })
                          .then(result => {
                            result.data.collectionByHandle.products.edges.forEach(
                              element => {
                                dataApi.push(element);
                              }
                            );
                            pageNextReady =
                              result.data.collectionByHandle.products.pageInfo
                                .hasNextPage;

                            if (pageNextReady == false) {
                              returnProductDataCallback(
                                Shopify.convertGraphQLToCollectionsFormatforCollections(
                                  dataApi
                                )
                              );
                            } else {
                              lastProductCursor =
                                result.data.collectionByHandle.products
                                  .edges[249].cursor;
                            }
                            // console.log(pageNextReady, lastProductCursor, result,'4')
                            if (pageNextReady == true) {
                              client
                                .query({
                                  query: GET_COLLECTTION_PRODUCTS_LOOP,
                                  variables: {
                                    firstNum: 250,
                                    handleName: handleName,
                                    sortKey: sortKey,
                                    lastProduct: lastProductCursor,
                                  },
                                })
                                .then(result => {
                                  result.data.collectionByHandle.products.edges.forEach(
                                    element => {
                                      dataApi.push(element);
                                    }
                                  );
                                  pageNextReady =
                                    result.data.collectionByHandle.products
                                      .pageInfo.hasNextPage;
                                  // console.log(pageNextReady, lastProductCursor, result,'5')
                                  if (pageNextReady == false) {
                                    returnProductDataCallback(
                                      Shopify.convertGraphQLToCollectionsFormatforCollections(
                                        dataApi
                                      )
                                    );
                                  } else {
                                    lastProductCursor =
                                      result.data.collectionByHandle.products
                                        .edges[249].cursor;
                                  }
                                  if (pageNextReady == true) {
                                    client
                                      .query({
                                        query: GET_COLLECTTION_PRODUCTS_LOOP,
                                        variables: {
                                          firstNum: 250,
                                          handleName: handleName,
                                          sortKey: sortKey,
                                          lastProduct: lastProductCursor,
                                        },
                                      })
                                      .then(result => {
                                        result.data.collectionByHandle.products.edges.forEach(
                                          element => {
                                            dataApi.push(element);
                                          }
                                        );
                                        pageNextReady =
                                          result.data.collectionByHandle
                                            .products.pageInfo.hasNextPage;
                                        // console.log(pageNextReady, lastProductCursor, result,'6')
                                        if (pageNextReady == false) {
                                          returnProductDataCallback(
                                            Shopify.convertGraphQLToCollectionsFormatforCollections(
                                              dataApi
                                            )
                                          );
                                        } else {
                                          lastProductCursor =
                                            result.data.collectionByHandle
                                              .products.edges[249].cursor;
                                        }
                                      });
                                  } else {
                                    returnProductDataCallback(
                                      Shopify.convertGraphQLToCollectionsFormatforCollections(
                                        dataApi
                                      )
                                    );
                                  }
                                });
                            } else {
                              returnProductDataCallback(
                                Shopify.convertGraphQLToCollectionsFormatforCollections(
                                  dataApi
                                )
                              );
                            }
                          });
                      } else {
                        returnProductDataCallback(
                          Shopify.convertGraphQLToCollectionsFormatforCollections(
                            dataApi
                          )
                        );
                      }
                    });
                } else {
                  returnProductDataCallback(
                    Shopify.convertGraphQLToCollectionsFormatforCollections(
                      dataApi
                    )
                  );
                }
              });
          } else {
            returnProductDataCallback(
              Shopify.convertGraphQLToCollectionsFormatforCollections(dataApi)
            );
          }
        },
        rejected => {
          console.error(rejected);
          errorCallback();
        }
      );
  },

  convertGraphQLToCompatioFormat: function(graphQLData, categoryID) {
    let productsVariants = [];
    graphQLData.data.products.edges.map(data => {
      const productID = this.getVariantId(data.node.id);
      data.node.variants.edges.map(prodVariant => {
        const variantID = this.getVariantId(prodVariant.node.id);
        if (39518570741954 == variantID) {
          // console.log(data.node.productType,productID)
        }
        if (prodVariant.node.availableForSale) {
          productsVariants.push({
            merchantProductSku: variantID,
            parentProductId: productID,
            variantTitle: prodVariant.node.title,
            variantName: `${data.node.title} - ${prodVariant.node.title}`,
            productName: `${data.node.title}`,
            categoryNames: `${data.node.productType}`,
            productDescription: `${data.node.descriptionHtml}`,
            productHandle: `${data.node.handle}`,
            url_product: `${window.compatioConfig.shopify.baseUrlDefault}/products/${data.node.handle}?variant=${variantID}`,
            url_image:
              prodVariant.node.image === null
                ? 'https://cdn0.iconfinder.com/data/icons/symbols-add-on-2-vol-1/48/v-03-512.png'
                : prodVariant.node.image.url,
            price: parseFloat(prodVariant.node.priceV2.amount),
            compareAtPrice: parseFloat(
              prodVariant.node.compareAtPriceV2
                ? prodVariant.node.compareAtPriceV2.amount
                : ''
            ),
            availableForSale: prodVariant.node.availableForSale,
            categoryName:
              categoryID !== undefined ? categoryID : data.node.productType,
            // currency: graphQLData.data.shop.currencyCode,
            options: prodVariant.node.selectedOptions,
          });
        }
      });
    }, this);
    return { data: productsVariants };
  },

  convertGraphQLToCompatioFormatXrsNew: function(graphQLData, categoryID) {
    let productsVariants = [];
    graphQLData.data.products.edges.map(data => {
      const productID = this.getVariantId(data.node.id);
      data.node.variants.edges.map(prodVariant => {
        const variantID = this.getVariantId(prodVariant.node.id);
        if (prodVariant.node.availableForSale) {
          productsVariants.push({
            merchantProductSku: variantID,
            parentProductId: productID,
            variantTitle: prodVariant.node.title,
            variantName: `${data.node.title} - ${prodVariant.node.title}`,
            productName: `${data.node.title}`,
            categoryNames: `${data.node.productType}`,
            productDescription: `${data.node.descriptionHtml}`,
            productHandle: `${data.node.handle}`,
            url_product: `${window.compatioConfig.shopify.baseUrlDefault}/products/${data.node.handle}?variant=${variantID}`,
            url_image:
              prodVariant.node.image === null
                ? 'https://cdn0.iconfinder.com/data/icons/symbols-add-on-2-vol-1/48/v-03-512.png'
                : prodVariant.node.image.url,
            price: parseFloat(prodVariant.node.priceV2.amount),
            compareAtPrice: parseFloat(
              prodVariant.node.compareAtPriceV2
                ? prodVariant.node.compareAtPriceV2.amount
                : ''
            ),
            availableForSale: prodVariant.node.availableForSale,
            categoryName:
              categoryID !== undefined ? categoryID : data.node.productType,
            // currency: graphQLData.data.shop.currencyCode,
            options: prodVariant.node.selectedOptions,
          });
        }
      });
    }, this);
    return { data: productsVariants };
  },

  convertGraphQLToCompatioFormatXrs: function(
    graphQLData,
    categoryID,
    currencySet
  ) {
    // console.log(graphQLData, categoryID);
    let productsVariants = [];
    graphQLData.map(data => {
      const productID = this.getVariantId(data.node.id);
      data.node.variants.edges.map(prodVariant => {
        // console.log(data.node.productType);
        const variantID = this.getVariantId(prodVariant.node.id);
        if (prodVariant.node.availableForSale) {
          productsVariants.push({
            merchantProductSku: variantID,
            parentProductId: productID,
            variantTitle: prodVariant.node.title,
            variantName: `${data.node.title} - ${prodVariant.node.title}`,
            productName: `${data.node.title}`,
            categoryNames: `${data.node.productType}`,
            productDescription: `${data.node.descriptionHtml}`,
            productHandle: `${data.node.handle}`,
            url_product: `${window.compatioConfig.shopify.baseUrlDefault}/products/${data.node.handle}?variant=${variantID}`,
            url_image:
              prodVariant.node.image === null
                ? 'https://cdn0.iconfinder.com/data/icons/symbols-add-on-2-vol-1/48/v-03-512.png'
                : prodVariant.node.image.url,
            price: parseFloat(prodVariant.node.priceV2.amount),
            compareAtPrice: parseFloat(
              prodVariant.node.compareAtPriceV2
                ? prodVariant.node.compareAtPriceV2.amount
                : ''
            ),
            availableForSale: prodVariant.node.availableForSale,
            categoryName:
              categoryID !== undefined ? categoryID : data.node.productType,
            currency: currencySet,
            options: prodVariant.node.selectedOptions,
          });
        }
      });
    }, this);
    return { data: productsVariants };
  },

  // New Fuction Increase product limit start in smartBuilder
  convertGraphQLToCompatioFormatSmartBuilder: function(
    graphQLData,
    categoryID,
    currencySet
  ) {
    let productsVariants = [];
    // console.log(graphQLData,'graphQLData')
    graphQLData.map(data => {
      const productID = this.getVariantId(data.node.id);
      data.node.variants.edges.map(prodVariant => {
        const variantID = this.getVariantId(prodVariant.node.id);
        if (prodVariant.node.availableForSale) {
          productsVariants.push({
            merchantProductSku: variantID,
            parentProductId: productID,
            variantTitle: prodVariant.node.title,
            variantName: `${data.node.title} - ${prodVariant.node.title}`,
            productName: `${data.node.title}`,
            categoryNames: `${data.node.productType}`,
            productDescription: `${data.node.descriptionHtml}`,
            productHandle: `${data.node.handle}`,
            url_product: `${window.compatioConfig.shopify.baseUrlDefault}/products/${data.node.handle}?variant=${variantID}`,
            url_image:
              prodVariant.node.image === null
                ? 'https://cdn0.iconfinder.com/data/icons/symbols-add-on-2-vol-1/48/v-03-512.png'
                : prodVariant.node.image.url,
            price: parseFloat(prodVariant.node.priceV2.amount),
            compareAtPrice: parseFloat(
              prodVariant.node.compareAtPriceV2
                ? prodVariant.node.compareAtPriceV2.amount
                : ''
            ),
            availableForSale: prodVariant.node.availableForSale,
            categoryName:
              categoryID !== undefined ? categoryID : data.node.productType,
            currency: currencySet,
            options: prodVariant.node.selectedOptions,
          });
        }
      });
    }, this);
    return { data: productsVariants };
  },
  // New Fuction Increase product limit end in smartBuilder

  convertGraphQLToCollectionsFormat: function(graphQLData) {
    let productsInCollection = [];
    let productList = [];
    if (
      graphQLData &&
      graphQLData.data.collectionByHandle !== null &&
      graphQLData.data.collectionByHandle.products.edges.length > 0
    )
      graphQLData.data.collectionByHandle.products.edges.map(data => {
        const productID = this.getVariantId(data.node.id);
        const hoverImg = [];
        if (data.node.images.edges[1] !== undefined) {
          hoverImg.push(data.node.images.edges[1].node.url);
        } else {
        }
        let variantDetails = [];
        data.node.variants.edges.map(prodVariant => {
          const variantID = this.getVariantId(prodVariant.node.id);
          if (
            prodVariant.node.availableForSale &&
            !prodVariant.node.currentlyNotinStock
          ) {
            variantDetails.push({
              variantID: variantID,
              price: parseFloat(prodVariant.node.priceV2.amount),
              compareAtPrice: parseFloat(
                prodVariant.node.compareAtPriceV2
                  ? prodVariant.node.compareAtPriceV2.amount
                  : ''
              ),
              availableForSale: prodVariant.node.availableForSale,
              url_product: `${window.compatioConfig.shopify.baseUrlDefault}/products/${data.node.handle}?variant=${variantID}`,
              url_image:
                prodVariant.node.image != null && prodVariant.node.image.url,
            });
          }
        });
        if (variantDetails.length > 0) {
          productsInCollection.push({
            productID: productID,
            productVendor: data.node.vendor,
            productName: `${data.node.title}`,
            createdAt: data.node.createdAt,
            url_image: variantDetails[0].url_image,
            url_image_two: hoverImg[0],
            product_url: variantDetails[0].url_product,
            price: variantDetails[0].price,
            variants: variantDetails,
          });
        }
        if (productList.findIndex(each => each === productID) === -1)
          productList.push(productID);
      });
    return { collectionData: productsInCollection, productList };
  },

  convertGraphQLToCollectionsFormatforCollections: function(graphQLData) {
    // console.log(graphQLData, 'graphQLData');
    let productsInCollection = [];
    let productList = [];
    if (graphQLData && graphQLData.length > 0)
      graphQLData.map(data => {
        const productID = this.getVariantId(data.node.id);
        const hoverImg = [];
        if (data.node.images.edges[1] !== undefined) {
          hoverImg.push(data.node.images.edges[1].node.url);
        } else {
        }
        let variantDetails = [];
        data.node.variants.edges.map(prodVariant => {
          const variantID = this.getVariantId(prodVariant.node.id);
          if (
            prodVariant.node.availableForSale &&
            !prodVariant.node.currentlyNotinStock
          ) {
            variantDetails.push({
              variantID: variantID,
              price: parseFloat(prodVariant.node.priceV2.amount),
              productType: data.node.productType,
              productVendor: data.node.vendor,
              compareAtPrice: parseFloat(
                prodVariant.node.compareAtPriceV2
                  ? prodVariant.node.compareAtPriceV2.amount
                  : ''
              ),
              availableForSale: prodVariant.node.availableForSale,
              url_product: `${window.compatioConfig.shopify.baseUrlDefault}/products/${data.node.handle}?variant=${variantID}`,
              url_image:
                prodVariant.node.image != null && prodVariant.node.image.url,
            });
          }
        });
        if (variantDetails.length > 0) {
          productsInCollection.push({
            productID: productID,
            productType: data.node.productType,
            productVendor: data.node.vendor,
            productName: `${data.node.title}`,
            createdAt: data.node.createdAt,
            url_image: variantDetails[0].url_image,
            url_image_two: hoverImg[0],
            product_url: variantDetails[0].url_product,
            price: variantDetails[0].price,
            variants: variantDetails,
          });
        }
        if (productList.findIndex(each => each === productID) === -1)
          productList.push(productID);
      });
    return { collectionData: productsInCollection, productList };
  },

  getVariantId: encryptedID => {
    // let str = window.atob(encryptedID);
    let str = encryptedID.split('/');
    str = str[str.length - 1].toString();
    // console.log(str);
    return str;
  },
};

if (typeof _get(window, 'compatioConfig') !== 'object') {
  window.compatioConfig = {};
}

if (typeof _get(window, 'compatioConfig.compatibleProducts') !== 'object') {
  window.compatioConfig.compatibleProducts = {};
}

if (
  typeof _get(window, 'compatioConfig.compatibleProducts.callbacks') !==
  'object'
) {
  window.compatioConfig.compatibleProducts.callbacks = {};
}

if (typeof _get(window, 'compatioConfig.shopify') === 'object') {
  window.compatioConfig.compatibleProducts.callbacks.getProductsBySkus =
    Shopify.getProductsBySkus;
  window.compatioConfig.compatibleProducts.callbacks.getProductsBySkusXrs =
    Shopify.getProductsBySkusXrs;
  window.compatioConfig.compatibleProducts.callbacks.getDcProductsBySkus =
    Shopify.getDcProductsBySkus;
  window.compatioConfig.compatibleProducts.callbacks.getProductsByCollection =
    Shopify.getProductsByCollection;
}

// If function is already defined, don't override it
if (
  typeof _get(window, 'compatioConfig.shopify') === 'object' &&
  typeof _get(
    window,
    'compatioConfig.compatibleProducts.callbacks.getProductsBySkus'
  ) === 'undefined'
) {
  window.compatioConfig.compatibleProducts.callbacks.getProductsBySkus =
    Shopify.getProductsBySkus;
}

if (
  typeof _get(window, 'compatioConfig.shopify') === 'object' &&
  typeof _get(
    window,
    'compatioConfig.compatibleProducts.callbacks.getProductsBySkusXrs'
  ) === 'undefined'
) {
  window.compatioConfig.compatibleProducts.callbacks.getProductsBySkusXrs =
    Shopify.getProductsBySkusXrs;
}

if (
  typeof _get(window, 'compatioConfig.shopify') === 'object' &&
  typeof _get(
    window,
    'compatioConfig.compatibleProducts.callbacks.getDcProductsBySkus'
  ) === 'undefined'
) {
  window.compatioConfig.compatibleProducts.callbacks.getProductsBySkus =
    Shopify.getDcProductsBySkus;
}

// TODO: Refactor this to avoid using globals
window.compatioShopify = Shopify;

export default Shopify;
